/**
 * QuillForms Dependencies
 */

import { getDefaultThemeProperties } from '@quillforms/utils';

/**
 * Internal Dependencies
 */
import useFormContext from './use-form-context';

/**
 * External Dependencies
 */
import { size } from "lodash";
const useBlockTheme = blockThemeId => {
  const {
    formObj: {
      theme,
      themesList
    }
  } = useFormContext();
  let appliedTheme = theme;
  if (blockThemeId && themesList !== undefined && size(themesList) > 0) {
    appliedTheme = themesList.find($theme => $theme.id === blockThemeId)?.properties;
  }
  if (!appliedTheme) {
    appliedTheme = {};
  }
  return {
    ...getDefaultThemeProperties(),
    ...appliedTheme
  };
};
export default useBlockTheme;
//# sourceMappingURL=use-block-theme.js.map